<template>
  <span v-if="hasPhysician" class="physicianTooltip">
    <span v-if="hasAttdMD">
      <span v-for="(item, index) in exAttdMDHtml" :key="item">
        <span v-if="index != Object.keys(exAttdMDHtml).length - 1">{{item}},&nbsp;</span>
        <span v-else>{{item}}</span>
      </span>
    </span>
    <span v-if="hasboth">,&nbsp;</span>
    <span v-if="hasexRefMD">
      <span v-for="(item, index) in exRefMDHtml" :key="item" class="referringMD">
        <span v-if="index != Object.keys(exRefMDHtml).length - 1">{{item}},&nbsp;</span>
        <span v-else>{{item}}</span>
      </span>
    </span>
  </span>
  <span v-else>No physician data available</span>
</template>

<script>
export default {
  name: "PatientExamMultiviewPhysician",
  props: {
    exam: Object
  },
  data() {
    return {
      exAttdMDHtml: [],
      exRefMDHtml: []
    };
  },
  mounted() {
    this.displayexAttdMD();
    this.displayexRefMD();
  },
  computed: {
    hasPhysician() {
      return (
        (this.exam.exAttdMD !== undefined && this.exam.exAttdMD.length !== 0) ||
        (this.exam.exRefMD !== undefined && this.exam.exRefMD.length !== 0)
      );
    },
    hasAttdMD() {
      return (
        this.exam.exAttdMD !== undefined && this.exam.exAttdMD.length !== 0
      );
    },
    hasexRefMD() {
      return this.exam.exRefMD !== undefined && this.exam.exRefMD.length !== 0;
    },
    hasboth() {
      return (
        this.exam.exAttdMD !== undefined &&
        this.exam.exAttdMD.length !== 0 &&
        (this.exam.exRefMD !== undefined && this.exam.exRefMD.length !== 0)
      );
    }
  },
  methods: {
    displayexAttdMD() {
      if (this.hasAttdMD) {
        this.exam.exAttdMD.forEach(value => {
          this.exAttdMDHtml.push(this.getPhysicianName(value));
        });
      }
    },
    displayexRefMD() {
      if (this.hasexRefMD) {
        this.exam.exRefMD.forEach(value => {
          this.exRefMDHtml.push(this.getPhysicianName(value));
        });
      }
    },
    getPhysicianName(phySrNo) {
      let physician = this.$store.getters.physicians.find(
        obj => obj.phySrNo == phySrNo
      );
      return physician.firstName + " " + physician.lastName;
    }
  }
};
</script>

<style lang="scss">
.referringMD {
  color: #afafaf;
}
</style>